import { create } from 'zustand'

export type LoadingStepStatus = 'pending' | 'done' | 'error'

export interface LoadingStep {
  name: string
  status: LoadingStepStatus
}

interface LoadingState {
  steps: LoadingStep[]
  visible: boolean
  initSteps: () => void
  setStepStatus: (name: string, status: LoadingStepStatus) => void
  hide: () => void
  reset: () => void
}

const DEFAULT_STEPS: LoadingStep[] = [
  { name: 'Connexion serveur', status: 'pending' },
  { name: 'Chargement site', status: 'pending' },
  { name: 'Chargement etages', status: 'pending' },
  { name: 'Chargement zones', status: 'pending' },
  { name: 'Chargement murs', status: 'pending' },
  { name: 'Chargement chemins', status: 'pending' },
  { name: 'Connexion IoT', status: 'pending' },
  { name: 'Chargement occupants', status: 'pending' },
]

export const useLoadingStore = create<LoadingState>((set, get) => ({
  steps: [],
  visible: false,

  initSteps: () => set({
    steps: DEFAULT_STEPS.map((s) => ({ ...s, status: 'pending' as LoadingStepStatus })),
    visible: true,
  }),

  setStepStatus: (name, status) => {
    const steps = get().steps.map((s) =>
      s.name === name ? { ...s, status } : s
    )
    const allDone = steps.every((s) => s.status === 'done' || s.status === 'error')
    set({ steps, visible: allDone ? false : get().visible })
  },

  hide: () => set({ visible: false }),

  reset: () => set({ steps: [], visible: false }),
}))
